import React from 'react';
import { Container } from 'react-bootstrap';
import CMHeader from './CMHeader';
import CMFooter from './CMFooter'
import '../styles/site.scss';
import { useLocation } from 'react-router-dom';
import {Path} from '../App';
import SessionTimeoutModal from './SessionTimeoutModal';
import XSPSessionCheck from './SessionCheck';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import ErrorHandling from './ErrorHandling';
import GoogleAnalyticsScripts from './GoogleAnalyticsScripts';

// eslint-disable-next-line
export default (props: any) => {
    const { pathname } = useLocation();
    const isLoggedOut = (pathname === Path.Logout || pathname === Path.SSO || pathname === Path.Default);

    function ErrorFallback({ error }: FallbackProps) {
        return (
            <ErrorHandling message={error?.message} />
        )
    }

    return (
    <>
        <GoogleAnalyticsScripts />
        <CMHeader />
        <Container className={isLoggedOut ? "px-xl-0 main-logout" : "px-xl-0 main"}>
            <div>
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                    {props.children}
                </ErrorBoundary>
            </div>
        </Container>
        <CMFooter />
        {!isLoggedOut &&
            <>
                <SessionTimeoutModal />
                <XSPSessionCheck checkIntervalTime={60000}/>
            </>
        }        
    </>
);
}
